<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="formRule"
          class="el-form"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="系列名称" prop="name">
            <el-input
              v-model="dialogForm.name"
              placeholder="请输入系列名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="系列图片:" prop="fileProp">
            <div class="file-tip">图片要求：jpg, jpeg, png格式，小于2M</div>
            <UploadFile
              :limit="1"
              :fileList="fileList"
              :fileMaxSize="2"
              :accept="'.jpg,.jpeg,.png'"
              :value="dialogForm.fileProp"
              :httpRequest="uploadFile"
              :handleRemove="handleRemove"
            >
            </UploadFile>
          </el-form-item>
          <el-form-item label="等级设置" prop="level_list" style="margin-top: 20px;">
            <div>
              <el-button type="primary" @click="addGrade">新增</el-button>
              <el-table
                :data="dialogForm.level_list"
                style="width: 300px; margin: 20px 0"
                border
              >
                <el-table-column
                  align="center"
                  label="等级"
                  prop="grade"
                  height="500"
                />
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope"> 
                    <el-button
                      size="small"
                      type="danger"
                      @click="delet(scope.$index)"
                      >
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="上架状态">
            <el-switch
              v-model="dialogForm.enable"
            >
            </el-switch>
          </el-form-item>
          <el-form-item>
            <span class="dialog-footer">
              <el-button @click="resert">取消</el-button>
              <el-button type="primary" @click="submitForm('dialogForm')">提交</el-button>
            </span>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-dialog
      title="等级"
      :visible.sync="dialogVisible"
      width="20%"
      center
    >
      <el-input placeholder="请输入等级" v-model="level" style="width: 100%" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createSeriesApi, uploadFiles, updateSeries } from "@/api/radio.js"
import { getImgName } from "@/utils/cutImgName"
import UploadFile from "@/components/uploadFile"

export default {
  components: { UploadFile },
  data() {
    return {
      dialogImageUrl: '',
      getImgName,
      level: '',
      dialogVisible: false, // 模态框是否展示
      dialogForm: {
        name: '',
        fileProp: '',
        level_list: [],
        enable: true,
      }, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      tableData: [],
      fileList: [],
      formRule: {
        name: {
          required: true,
          message: "请输入系列名称",
          trigger: "blur",
        },
        level_list: {
          type: 'array',
          required: true,
          message: "请添加等级",
          trigger: "blur",
        },
        fileProp: { required: true, message: '请上传至少一个文件', trigger: 'change'},
      },
      type: '',
      id: null,
    };
  },
  created() {
    this.type = this.$route.query.type
    if(this.type == 'edit'){
      let param = JSON.parse(sessionStorage.getItem('series'))
      this.dialogForm.name = param.name
      this.dialogForm.enable = param.is_on_sale
      this.dialogForm.fileProp = param.pic
      this.id = param.id
      let level_list = []
      JSON.parse(param.level_list).forEach(item => {
        level_list.push({
          grade: item
        })
      })
      this.dialogForm.level_list = level_list
      this.fileList = [
        {
          name: this.getImgName(param.pic),
          url: param.pic,
        },
      ]
    }
  },
  mounted() {},

  methods: {
    
    
    resert(){
      this.$router.go(-1)
    },
    handleChange() {

    },
    uploadFile(params){
      let file = params.file;
      let formData = new FormData();
      formData.append("file", file);
      uploadFiles(formData).then(res => {
        if(res.data){
          this.dialogForm.fileProp = res.data.filePath
        }else {
          this.handleRemove()
        }
      }).catch(() => {
        this.handleRemove()
      })
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.dialogForm.fileProp = ''
    },
    // 文件超出限制时触发
    handleExceed() {
      this.$message.warning('只能上传一张图片，请重新选择！')
    },
    delet(index){
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogForm.level_list.splice(index,1)
      })
    },
    add(){
      this.dialogForm.level_list.push({
        grade: this.level && this.level.trim()
      })
      this.dialogVisible = false
    },
    addGrade(){
      this.level = ''
      this.dialogVisible = true
    },
    submitForm(){
      const levelList = this.dialogForm.level_list.map(item => item.grade)
        if(this.type == 'add'){
          let param = {
            name: this.dialogForm.name,
            pic: this.dialogForm.fileProp,
            is_on_sale: this.dialogForm.enable,
            level_list: JSON.stringify(levelList),
          }
          this.$refs.dialogForm.validate((valid) => {
            if(valid){
              this.$confirm('确认提交吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                createSeriesApi(param).then(res => {
                  if(res.data){
                    this.$router.go(-1)
                  }
                })
              })
            }
          })
      } else {
        let param = {
            name: this.dialogForm.name,
            pic: this.dialogForm.fileProp,
            is_on_sale: this.dialogForm.enable,
            level_list: JSON.stringify(levelList),
            id: this.id
        }
        this.$refs.dialogForm.validate((valid) => {
          if(valid){
            this.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              updateSeries(param).then(res => {
                if(res.data){
                  this.$router.go(-1)
                }
              })
            })
          }
        })
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.file-tip{
  color: red;
  font-weight: 600;
}
.el-form{
  ::v-deep .el-upload-list{
    // width: 500px;
  }
}
</style>
